// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"858":"1441935c","976":"379a528c"}[chunkId] + ".css";
};